import React, { useState, useEffect } from "react";
import { View, StyleSheet, Dimensions, Text, Image } from "react-native";
import LoadingLogo from "./LoadingLogo";
import { Chat } from "../../Resources/Constants";
import IconEmptyView from "./IconEmptyView";

const ImageComponent = ({
  imageURL,
  opacity = 1,
  width = "100%",
  height = "auto",
  maxHeight, // Optional: number or percentage string (e.g., "50%")
  borderRadius = 8,
  borderTopLeftRadius,
  borderTopRightRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  small = false,
  large = false,
  avoidLoading = false,
  dark = false,
}) => {
  const [loaded, setLoaded] = useState(false);

  const [finalHeight, setFinalHeight] = useState(
    small ? Chat.MEDIA_REPLY_HEIGHT : Chat.MEDIA_HEIGHT
  );
  const [error, setError] = useState(false);
  // Determine container width based on provided width prop or device width.
  const containerWidth =
    typeof width === "number" ? width : Dimensions.get("window").width - 24;

  // useEffect(() => {
  //   setLoaded(false);
  //   setError(false);
  // }, [imageURL]);
  // Convert maxHeight to a numeric value if provided.
  // const hasMaxHeight = maxHeight !== undefined && maxHeight !== null;
  // let numericMaxHeight = null;
  // if (hasMaxHeight) {
  //   if (typeof maxHeight === "string" && maxHeight.trim().endsWith("%")) {
  //     const percent = parseFloat(maxHeight) / 100;
  //     numericMaxHeight = Dimensions.get("window").height * percent;
  //   } else if (typeof maxHeight === "number") {
  //     numericMaxHeight = maxHeight;
  //   }
  // }
  const hasMaxHeight = false;
  // Consolidate border radius settings.
  const computedBorderRadius = {
    borderRadius,
    borderTopLeftRadius: borderTopLeftRadius ?? borderRadius,
    borderTopRightRadius: borderTopRightRadius ?? borderRadius,
    borderBottomLeftRadius: borderBottomLeftRadius ?? borderRadius,
    borderBottomRightRadius: borderBottomRightRadius ?? borderRadius,
  };

  // Define container style.
  const containerStyle = hasMaxHeight
    ? { height: finalHeight || "100%" }
    : { width, height };

  if (error && !loaded && large) {
    return (
      <View
        style={{
          width: "100%",
          height: "100%",
          flexGrow: 1,
          alignItems: "center",
          justifyContent: "center",
          // minHeight: 200,
        }}
      >
        <IconEmptyView
          iconLibrary={"Ionicons"}
          iconName={"warning-outline"}
          mainText={"imageNotAvailableTitle-string"}
          subText={"imageNotAvailableText-string"}
          marginTop={60}
          marginBottom={30}
        />
      </View>
    );
  }

  return (
    <View
      style={[
        containerStyle,
        {
          // flexShrink: 1,
          // flexGrow: 1,
          // flex: 2,
          // flexGrow: 2,
          ...computedBorderRadius,
          overflow: "hidden",
          justifyContent: "center",
          // alignItems: "center",
          // height: 100,
          minHeight: !loaded
            ? small
              ? Chat.MEDIA_REPLY_HEIGHT
              : Chat.MEDIA_HEIGHT
            : small
            ? 60
            : 90,
        },
      ]}
    >
      {/* Placeholder animation until image loads */}
      {!(loaded && !avoidLoading) && (
        <View
          style={[
            StyleSheet.absoluteFill,
            {
              ...computedBorderRadius,
              justifyContent: "center",
              alignItems: "center",
              zIndex: 4,
            },
          ]}
        >
          <LoadingLogo
            container={false}
            width={small ? 30 : large ? 75 : 50}
            height={small ? 30 : large ? 75 : 50}
            dark={dark}
          />
        </View>
      )}
      <img
        src={imageURL}
        key={imageURL}
        style={{
          // Ensure full width and auto height scaling, with a minimum height set.
          // minWidth: "100%",
          // height: "auto",
          minWidth: small ? Chat.MEDIA_REPLY_WIDTH : Chat.MEDIA_WIDTH,
          minHeight: !loaded
            ? small
              ? Chat.MEDIA_REPLY_HEIGHT
              : Chat.MEDIA_HEIGHT
            : small
            ? 60
            : 90,
          objectFit: "cover",
          ...computedBorderRadius,
          opacity: loaded ? opacity : 0,
        }}
        onLoad={(e) => {
          const img = e.target;
          const imgWidth = img.naturalWidth;
          const imgHeight = img.naturalHeight;
          const ratio = imgWidth / imgHeight;

          if (hasMaxHeight && numericMaxHeight) {
            const computedHeight = containerWidth / ratio;
            if (computedHeight > numericMaxHeight) {
              setFinalHeight(numericMaxHeight);
            } else {
              setFinalHeight(computedHeight);
            }
          } else {
            // setFinalHeight(ratio / 400);
            // setAspectRatio(ratio);
          }
          setLoaded(true);
        }}
        onError={(error) => {
          setError(true);
          console.error("Image failed to load", error);
        }}
      />
    </View>
  );
};
export default ImageComponent;

// import LottieView from "lottie-react-native";
// import React, { useState } from "react";
// import { View, Image, StyleSheet } from "react-native";
// import { useTheme } from "../../resources/ThemeProvider";

// const ImageComponent = ({
//   imageURL,
//   opacity = 1,
//   width = "auto",
//   height = "auto",
//   borderRadius = 8,
//   borderTopLeftRadius = undefined,
//   borderTopRightRadius = undefined,
//   borderBottomLeftRadius = undefined,
//   borderBottomRightRadius = undefined,
//   small = false,
// }) => {
//   const [aspectRatio, setAspectRatio] = useState(1);
//   const [loaded, setLoaded] = useState(false);
//   const { dark } = useTheme();
//   return (
//     <View style={{ width, height }}>
//       {/* Render placeholder if image is not loaded */}
//       {!loaded && (
//         <View
//           style={{
//             borderRadius: borderRadius,
//             borderTopLeftRadius: borderTopLeftRadius ?? borderRadius,
//             borderTopRightRadius: borderTopRightRadius ?? borderRadius,
//             borderBottomLeftRadius: borderBottomLeftRadius ?? borderRadius,
//             borderBottomRightRadius: borderBottomRightRadius ?? borderRadius,
//             justifyContent: "center",
//             alignItems: "center",
//             position: "absolute",
//             flex: 1,
//             alignSelf: "center",
//             bottom: 0,
//             right: 0,
//             left: 0,
//             top: 0,
//             zIndex: 4,
//           }}
//         >
//           <LottieView
//             source={
//               dark
//                 ? require("../../assets/WhiteLogoAnimation.json")
//                 : require("../../assets/BlackLogoAnimation.json")
//             }
//             autoPlay
//             loop
//             style={{
//               width: small ? 30 : 50,
//               height: small ? 30 : 50,
//             }}
//           />
//         </View>
//       )}

//       <Image
//         source={{ uri: imageURL }}
//         style={{
//           width,
//           height,
//           aspectRatio,
//           opacity: loaded ? opacity : 0, // Hide image until loaded
//           borderRadius: borderRadius,
//           borderTopLeftRadius: borderTopLeftRadius ?? borderRadius,
//           borderTopRightRadius: borderTopRightRadius ?? borderRadius,
//           borderBottomLeftRadius: borderBottomLeftRadius ?? borderRadius,
//           borderBottomRightRadius: borderBottomRightRadius ?? borderRadius,
//         }}
//         resizeMode="contain"
//         onLoad={(event) => {
//           const { width: imgWidth, height: imgHeight } =
//             event.nativeEvent.source;
//           setAspectRatio(imgWidth / imgHeight);
//           setLoaded(true);
//         }}
//         onError={(error) => {
//           console.error("Image failed to load", error);
//           // Optionally set a default aspect ratio or fallback image
//           setLoaded(true);
//         }}
//       />
//     </View>
//   );
// };

// export default ImageComponent;

// const ImageComponent = ({
//   imageURL,
//   opacity = 1,
//   width = "100%",
//   height = "auto",
//   maxHeight, // Optional: number or percentage string (e.g., "50%")
//   borderRadius = 8,
//   borderTopLeftRadius,
//   borderTopRightRadius,
//   borderBottomLeftRadius,
//   borderBottomRightRadius,
//   small = false,
//   keyId,
// }) => {
//   const { dark, colors } = useTheme();
//   const [loaded, setLoaded] = useState(false);
//   const [aspectRatio, setAspectRatio] = useState(1);
//   const [finalWidth, setFinalWidth] = useState(null);
//   const [finalHeight, setFinalHeight] = useState(null);

//   const hasMaxHeight = maxHeight !== undefined && maxHeight !== null;
//   const containerWidth =
//     typeof width === "number" ? width : Dimensions.get("window").width - 24;

//   // Convert maxHeight to a numeric value if given as a percentage or a number.
//   let numericMaxHeight = null;
//   if (hasMaxHeight) {
//     if (typeof maxHeight === "string" && maxHeight.trim().endsWith("%")) {
//       const percent = parseFloat(maxHeight) / 100;
//       numericMaxHeight = Dimensions.get("window").height * percent;
//     } else if (typeof maxHeight === "number") {
//       numericMaxHeight = maxHeight;
//     }
//   }

//   // Consolidate border radius settings.
//   const computedBorderRadius = {
//     borderRadius,
//     borderTopLeftRadius: borderTopLeftRadius ?? borderRadius,
//     borderTopRightRadius: borderTopRightRadius ?? borderRadius,
//     borderBottomLeftRadius: borderBottomLeftRadius ?? borderRadius,
//     borderBottomRightRadius: borderBottomRightRadius ?? borderRadius,
//   };

//   const containerStyle = hasMaxHeight
//     ? { width: containerWidth, height: finalHeight || "100%" }
//     : { width, height };

//   const validAspectRatio =
//     isNaN(aspectRatio) || aspectRatio <= 0 ? 1 : aspectRatio;

//   const imageStyle = hasMaxHeight
//     ? {
//         height: "100%",
//         opacity: loaded ? opacity : 0,
//         ...computedBorderRadius,
//       }
//     : {
//         width,
//         height,
//         aspectRatio: validAspectRatio,
//         // flexShrink: 1,
//         opacity: loaded ? opacity : 0,
//         ...computedBorderRadius,
//       };

//   // const timestamp = new Date().getTime();

//   // console.log("Image URL:", imageURL);

//   return (
//     <View
//       style={[
//         containerStyle,
//         {
//           flexShrink: 1,
//           ...computedBorderRadius,
//           overflow: "hidden",
//           justifyContent: "center",
//           // width: "100%",
//           // height: "100%",
//         },
//       ]}
//     >
//       {/* Placeholder animation until image loads */}
//       {!loaded && (
//         <View
//           style={[
//             StyleSheet.absoluteFill,
//             {
//               ...computedBorderRadius,
//               justifyContent: "center",
//               alignItems: "center",
//               zIndex: 4,
//             },
//           ]}
//         >
//           <LottieView
//             source={
//               dark
//                 ? require("../../assets/WhiteLogoAnimation.json")
//                 : require("../../assets/BlackLogoAnimation.json")
//             }
//             autoPlay
//             loop
//             style={{
//               width: small ? 30 : 50,
//               height: small ? 30 : 50,
//             }}
//           />
//         </View>
//       )}
//       <Image
//         source={imageURL}
//         // style={{ flex: 1, width: 100 }}
//         style={imageStyle}
//         contentFit="contain"
//         // cachePolicy="none"
//         recyclingKey={keyId ? "1" : "2"}
//         onLoad={(event) => {
//           console.log("event", event);
//           // Extract width and height from nativeEvent.source.
//           const { source } = event.nativeEvent;
//           const imgWidth = source.width;
//           const imgHeight = source.height;
//           // Guard against division by zero.
//           const ratio = imgHeight ? imgWidth / imgHeight : 1;
//           if (hasMaxHeight && numericMaxHeight) {
//             const computedHeight = containerWidth / ratio;
//             if (computedHeight > numericMaxHeight) {
//               setFinalHeight(numericMaxHeight);
//               setFinalWidth(numericMaxHeight * ratio);
//             } else {
//               setFinalWidth(containerWidth);
//               setFinalHeight(computedHeight);
//             }
//           } else {
//             setAspectRatio(ratio);
//           }
//           setLoaded(true);
//         }}
//         onError={(error) => {
//           console.error("ExpoImage failed to load", error);
//           setLoaded(true);
//         }}
//       />
//       {/* <FastImage
//         source={{ uri: imageURL}}
//         style={imageStyle}
//         resizeMode={FastImage.resizeMode.contain}
//         onLoad={(event) => {
//           // FastImage onLoad event nativeEvent includes width and height directly.
//           const { width: imgWidth, height: imgHeight } = event.nativeEvent;
//           const ratio = imgWidth / imgHeight;
//           if (hasMaxHeight && numericMaxHeight) {
//             const computedHeight = containerWidth / ratio;
//             if (computedHeight > numericMaxHeight) {
//               setFinalHeight(numericMaxHeight);
//               setFinalWidth(numericMaxHeight * ratio);
//             } else {
//               setFinalWidth(containerWidth);
//               setFinalHeight(computedHeight);
//             }
//           } else {
//             setAspectRatio(ratio);
//           }
//           setLoaded(true);
//         }}
//         onError={(error) => {
//           console.error("FastImage failed to load", error);
//           setLoaded(true);
//         }}
//       /> */}
//     </View>
//   );
// };
